enum AlertModel {
  AreaAlert = 'AreaAlert',
  TrailAlert = 'TrailAlert'
}

export default AlertModel;
